/**
 * Warning Suppressions
 * Suppresses known development warnings that don't affect functionality
 */

// Suppress React DevTools warning and other development warnings
const originalWarn = console.warn;
console.warn = (...args) => {
  const message = args.join(' ');
  
  // Suppress specific warnings
  const suppressedWarnings = [
    'Download the React DevTools',
    'shadow* style props are deprecated',
    'textShadow* style props are deprecated',
    'No TTS providers configured',
    'Browser TTS not available',
    'Using \'compiler\' as the first argument is deprecated',
    '\'listen\' is deprecated'
  ];
  
  if (suppressedWarnings.some(warning => message.includes(warning))) {
    return;
  }
  
  originalWarn.apply(console, args);
};

// Suppress debug logs in production
if (process.env.NODE_ENV === 'production') {
  const originalLog = console.log;
  console.log = (...args) => {
    const message = args.join(' ');
    
    // Only suppress specific debug messages
    const suppressedLogs = [
      'SUPABASE_URL:',
      'SUPABASE_ANON_KEY:',
      'Initializing Supabase client',
      'Supabase client initialized',
      '[analytics] Web analytics initialized',
      '[analytics] Track event:',
      '[sentry] Browser Sentry initialized'
    ];
    
    if (suppressedLogs.some(log => message.includes(log))) {
      return;
    }
    
    originalLog.apply(console, args);
  };
}

// Handle known harmless errors without hiding app/runtime failures.
const originalError = console.error;
console.error = (...args) => {
  const message = args.join(' ');

  // Suppress custom element duplicate registration errors
  if (message.includes('custom element') && message.includes('already been defined')) {
    return;
  }

  // Suppress touch event warnings
  if (message.includes('Cannot record touch end without a touch start')) {
    return;
  }

  // Suppress webpack dev server deprecation warnings
  if (message.includes('DEP_WEBPACK_DEV_SERVER')) {
    return;
  }

  // Amplitude's browser cookie probe runs in React Native dev-client and logs
  // a harmless document.cookie failure as an error overlay.
  if (message.includes('Amplitude Logger') && message.includes('Failed to set cookie')) {
    return;
  }

  originalError.apply(console, args);
};

// Handle custom element registration errors and other web-only rejections.
if (typeof window !== 'undefined') {
  // Handle unhandled promise rejections (web only)
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('unhandledrejection', (event) => {
      const message = event.reason?.message || event.reason || '';
      
      // Suppress known harmless rejections
      if (typeof message === 'string') {
        if (message.includes('custom element') || 
            message.includes('already been defined') ||
            message.includes('touch end without a touch start')) {
          event.preventDefault();
          return;
        }
      }
    });
  }
}

export {};
